export default "__VITE_ASSET__6d1f67e5__"